import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
} from "@material-ui/core";
import ButtonCommon from "../../../../components/buttons/ButtonCommon";

interface LockTypeDialogProps {
  open: boolean;
  onClose: () => void;
  onSelect: (
    type: "location-lock" | "device-lock" | "location-active" | "device-active"
  ) => void;
  mode: "lock" | "activate";
}

const LockTypeDialog: React.FC<LockTypeDialogProps> = ({
  open,
  onClose,
  onSelect,
  mode,
}) => {
  const options =
    mode === "lock"
      ? [
          { type: "location-lock", label: "Location Lock", color: "red" },
          { type: "device-lock", label: "Device Lock", color: "yellow" },
        ]
      : [
          { type: "location-active", label: "Location Activate", color: "green" },
          { type: "device-active", label: "Device Activate", color: "yellow" },
        ];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        Select {mode === "lock" ? "Lock" : "Activate"} Type
      </DialogTitle>
      <DialogContent>
        <Typography style={{ marginBottom: 16 }}>
          Please choose an action:
        </Typography>
        <Box display="flex" justifyContent="space-between" style={{ gap: 12 }}>
          {options.map((opt) => (
            <ButtonCommon
              key={opt.type}
              onClick={() => {
                onSelect(opt.type as any);
                onClose();
              }}
              color={opt.color as any}
              style={{
                flex: 1,
                height: 36, 
              }}
            >
              {opt.label}
            </ButtonCommon>
          ))}
        </Box>
      </DialogContent>
      <DialogActions>
        <ButtonCommon
          variant="contained"
          color="orange"
          onClick={onClose}
          style={{
            minWidth: 120,
            height: 36, // ✅ Consistent height
          }}
        >
          Cancel
        </ButtonCommon>
      </DialogActions>
    </Dialog>
  );
};

export default LockTypeDialog;
